"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupTocHighlight = void 0;
const escapeHtml = (text) => text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
function TocList(items) {
    return `
    <ul class="flex flex-col gap-0.5 text-caption1">
      ${items
        .map((item) => `
        <li>
          <a href="#${item.id}" data-toc="${item.id}" class="block py-0.5 border-0 border-l-2 border-solid border-line text-muted hover:text-white-200 ${item.level === 3 ? "pl-6" : "pl-3"}">${escapeHtml(item.text)}</a>
        </li>`)
        .join("")}
    </ul>`;
}
function TableOfContents(items) {
    if (items.length < 3)
        return { inline: "", side: "" };
    return {
        inline: `
    <details class="xl:hidden mb-8 p-4 rounded-lg border border-solid border-line">
      <summary class="cursor-pointer font-GmarketSansMedium">목차</summary>
      <div class="mt-3">${TocList(items)}</div>
    </details>`,
        // 360px은 Layout 본문 폭(w-medium, 720px)의 절반이라 본문 오른쪽 바깥에 붙는다
        side: `
    <aside class="hidden xl:block fixed top-32 w-56 max-h-[70vh] overflow-y-auto" style="left: calc(50% + 360px + 2rem)">
      <div class="mb-3 text-caption1 font-GmarketSansMedium text-white-200">목차</div>
      ${TocList(items)}
    </aside>`,
    };
}
exports.default = TableOfContents;
const ACTIVE_CLASSES = [
    "!text-white-100",
    "font-GmarketSansMedium",
    "!border-accent",
];
function setupTocHighlight(root, items) {
    if (items.length < 3)
        return;
    let activeId = null;
    const update = () => {
        // 라우터가 다른 페이지로 바꾸면 root가 DOM에서 빠지므로 그때 리스너를 정리한다
        if (!root.isConnected) {
            window.removeEventListener("scroll", update);
            return;
        }
        let currentId = items[0].id;
        for (const item of items) {
            const heading = root.querySelector(`#${item.id}`);
            if (heading && heading.getBoundingClientRect().top <= 120) {
                currentId = item.id;
            }
        }
        if (currentId === activeId)
            return;
        activeId = currentId;
        root.querySelectorAll("a[data-toc]").forEach((link) => {
            const isActive = link.dataset.toc === currentId;
            ACTIVE_CLASSES.forEach((c) => link.classList.toggle(c, isActive));
        });
    };
    window.addEventListener("scroll", update, { passive: true });
    update();
}
exports.setupTocHighlight = setupTocHighlight;
